import {
    formatDateNoTime,
    formattedDateTimeDefault,
    inPast,
    Maybe,
    withinSevenDays,
} from "@sp-crm/core";
import * as React from "react";

interface NextTaskLike {
    text?: string | null;
    dueDate?: string | null;
    dueDateTime?: string | null;
}

export const badgeColorForDate = (theDate: Maybe<Date>): string => {
    if (!theDate || !theDate.hasValue) {
        return "bg-gray-300";
    }
    const actualDate = theDate.get();
    if (inPast(actualDate)) {
        return "bg-red-600";
    }
    if (withinSevenDays(actualDate)) {
        return "bg-yellow-400";
    }
    return "bg-green-500";
};

export const dueDateFromNextTask = (
    nextTask: NextTaskLike | null | undefined,
): Maybe<Date> => {
    if (!nextTask) {
        return Maybe.none();
    }
    if (nextTask.dueDateTime) {
        return Maybe.fromValue(new Date(nextTask.dueDateTime));
    }
    if (nextTask.dueDate) {
        return Maybe.fromValue(new Date(nextTask.dueDate));
    }
    return Maybe.none();
};

export const badgeColorForNextTask = (
    nextTask: NextTaskLike | null | undefined,
): string => badgeColorForDate(dueDateFromNextTask(nextTask));

export const NextActionLine: React.FC<{
    nextTask: NextTaskLike | null | undefined;
}> = ({ nextTask }) => {
    if (!nextTask) {
        return <div className="font-light text-xs text-gray-600">No tasks</div>;
    }
    if (nextTask.dueDateTime) {
        return (
            <div>
                <div className="font-semibold">{nextTask.text}</div>
                <div>Due: {formattedDateTimeDefault(nextTask.dueDateTime)}</div>
            </div>
        );
    }
    if (nextTask.dueDate) {
        return (
            <div>
                <div className="font-semibold">{nextTask.text}</div>
                <div>Due: {formatDateNoTime(nextTask.dueDate)}</div>
            </div>
        );
    }
    return (
        <div>
            <div className="font-semibold">{nextTask.text}</div>
        </div>
    );
};
